import { render, staticRenderFns } from "./SliderInput.vue?vue&type=template&id=010a53e5&"
import script from "./SliderInput.vue?vue&type=script&lang=js&"
export * from "./SliderInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports